export const environment = {
  configApiURL: 'https://tymes4-v2-app-qa-api-fanmanagement.azurewebsites.net/v2/',
  production: true
};
